<template>
  <router-link
    v-if="to"
    :to="to" exact
    class="menu-item d-flex align-center"
  >
    <fai :icon="icon" class="mr-2 icon text-h6" />
    <h4
      class="text-uppercase lh-1 text-body-1 font-weight-semibold"
      v-text="title"
    />
    <slot name="suffix" />
  </router-link>
  <a
    v-else
    class="menu-item d-flex align-center"
  >
    <fai :icon="icon" class="mr-2 icon text-h6" />
    <h4
      class="text-uppercase lh-1 text-body-1 font-weight-semibold"
      v-text="title"
    />
    <slot name="suffix" />
  </a>
</template>

<script>
export default {
  props: {
    to: {
      type: [Object, String],
      default: null,
    },
    icon: {
      type: [Array, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-item {
  text-decoration: none;

  .icon,
  ::v-deep .suffix,
  h4 {
    transition: color 0.3s ease;
  }

  h4.text-body-1,
  ::v-deep .suffix,
  .icon {
    color: grey(200);
  }

  &.router-link-exact-active,
  &:hover {
    h4.text-body-1,
    ::v-deep .suffix,
    .icon {
      color: primary();
    }
  }
}
</style>
